import { Tooltip as AntdTooltip } from 'antd'
import type { TooltipProps as AntdTooltipProps } from 'antd'

export type TooltipProps = AntdTooltipProps

export function Tooltip(props: TooltipProps) {
  return <AntdTooltip {...props} />
}
